var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.15385L14.7071 6.44674L15.4142 7.15385L14.7071 7.86095L14 7.15385ZM0.692307 1C0.692307 0.447716 1.14002 1.12425e-06 1.69231 1.07597e-06C2.24459 1.02769e-06 2.69231 0.447716 2.69231 1L0.692307 1ZM10.861 2.60059L14.7071 6.44674L13.2929 7.86095L9.44674 4.0148L10.861 2.60059ZM14.7071 7.86095L10.861 11.7071L9.44674 10.2929L13.2929 6.44674L14.7071 7.86095ZM14 8.15385L7.69231 8.15385L7.69231 6.15385L14 6.15385L14 8.15385ZM0.692307 1.15385L0.692307 1L2.69231 1L2.69231 1.15385L0.692307 1.15385ZM7.69231 8.15385C3.82632 8.15385 0.692308 5.01984 0.692307 1.15385L2.69231 1.15385C2.69231 3.91527 4.93089 6.15385 7.69231 6.15385L7.69231 8.15385Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.674ac774e8a5e73ba7ad8b347df22667.svg";
export { ForwardRef as ReactComponent };